/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import $ from "jquery"
import ReactDOM from "react-dom/client"

export const replaceHydrateFunction = () => {
  return (element, container, callback) => {
    const root = ReactDOM.createRoot(container) // 创建一个 root
    root.render(element, callback) // 使用 root.render 替代 ReactDOM.render
  }
}

export const onClientEntry = () => {
  // 确保 DOMContentLoaded 事件已经触发
  function runOnClient() {
    //# 文字亂數 Plugin
    // API 參考： https://github.com/masteryder/splitflap
    const splitFlapDefaults = {
      nbJumpIterations: 10, // 例子值，表示跳跃迭代的次数
      timeOut: 1000, // 例子值，表示更换文本之前的等待时间（毫秒）
      tickTimeOut: 100, // 例子值，表示字符变化的间隔时间（毫秒）
    }

    String.prototype.replaceAt = function (index, replacement) {
      let left
      let right

      if (this.substr(0, index) == undefined) {
        left = ""
      } else {
        left = this.substr(0, index)
      }

      if (this.substr(index + replacement.length) == undefined) {
        right = ""
      } else {
        right = this.substr(index + replacement.length)
      }
      return left + replacement + right
    }

    /*
     *
     */
    function splitFlap(domElement, texts, options = splitFlapDefaults) {
      let curIndex = -1
      let curDoneIterations = 0
      let curText
      let curEndText

      const nbJumpIterations = options.nbJumpIterations
      const timeOut = options.timeOut
      const tickTimeOut = options.tickTimeOut

      setTimeout(changeText, timeOut)

      function changeText() {
        let beforeText
        let afterText

        if (curIndex >= 0) {
          beforeText = texts[curIndex]
          if (curIndex == texts.length - 1) {
            afterText = texts[0]
          } else {
            afterText = texts[curIndex + 1]
          }
        } else {
          beforeText = domElement.innerText
          afterText = texts[0]
        }
        updateIndex()
        transitionText(beforeText, afterText)
      }

      function updateIndex() {
        if (curIndex < texts.length - 1) {
          curIndex++
        } else {
          curIndex = 0
        }
      }

      function transitionText(startText, endText) {
        curText = startText

        if (endText.length < curText.length) {
          let diff = curText.length - endText.length
          curEndText = endText + " ".repeat(diff)
        } else {
          curEndText = endText
        }
        transitionTextTick()
      }

      function transitionTextTick() {
        let endLength
        let startLength

        if (curText.length == null) {
          startLength = 0
        } else {
          startLength = curText.length
        }
        if (curEndText.length == null) {
          endLength = 0
        } else {
          endLength = curEndText.length
        }

        var longestLength = startLength >= endLength ? startLength : endLength

        for (var i = 0; i < longestLength; i++) {
          let curCharCode = curText.charCodeAt(i)

          if (curCharCode == undefined || isNaN(curCharCode)) {
            curCharCode = String.fromCharCode(32)
            curText = curText.replaceAt(i, curCharCode)
          } else {
            if (curText.charAt(i) != curEndText.charAt(i)) {
              if (curCharCode >= 126 || curCharCode < 32) {
                curCharCode = 32
              } else {
                curCharCode++
              }
              curText = curText.replaceAt(i, String.fromCharCode(curCharCode))
            }
          }
        }

        if (
          curDoneIterations >= nbJumpIterations ||
          curText.trim().localeCompare(curEndText.trim()) == 0
        ) {
          domElement.innerText = curText

          if (curText.trim().localeCompare(curEndText.trim()) != 0) {
            setTimeout(transitionTextTick, tickTimeOut)
          } else {
            setTimeout(changeText, timeOut)
          }
          curDoneIterations = 0
        } else {
          curDoneIterations++
          transitionTextTick()
        }
      }
    }
    //# End of 文字亂數 Plugin
    $(document).ready(function () {
      let cards = document.querySelectorAll(".card")
      let cardsIndexes = [...Array(cards.length).keys()] // 假设的初始化
      let isFromAnchor = false

      //# 首頁影片 Lightbox
      let w = window.innerWidth
      let autoplay = w < 768 ? "" : "autoplay=1&mute=1&"
      $(".openbox").click(function () {
        var vidNum = $(this).attr("data-video").replace("watch?v=", "embed/")
        let uri = vidNum + "?" + autoplay + "showinfo=0"
        let title = $(this)
          .parents(".swiper-slide ")
          .find(".info .title")
          .text()

        $("#video").parents(".lightbox-wrap").fadeIn(400)
        $("#video").attr("src", uri)
        $(".head .title").text(title)
      })

      //click X
      $(".closebox, .lightbox-wrap").click(function () {
        $(".lightbox-wrap").fadeOut(400)
        $("#video").attr("src", "")
      })

      //esc keydown
      $(document).keydown(function (event) {
        if (event.which == 27) {
          $(".lightbox-wrap").fadeOut(400)
          $("#video").attr("src", "")
        }
      })
      //# End of 首頁影片 Lightbox

      //# gamers 圖片 Lightbox

      $(".open").click(function () {
        let title = $(this)
          .parents(".swiper-slide ")
          .find(".info .title")
          .text()
        $("#image").parents(".lightbox-wrap").fadeIn(400)
        $(this).find("img").clone().appendTo("#image")
        $(".head .title").text(title)
      })

      //click X
      $(".closebox, .lightbox-wrap").click(function () {
        $(".lightbox-wrap").fadeOut(400)
        $("#image").html("")
      })

      //esc keydown
      $(document).keydown(function (event) {
        if (event.which == 27) {
          $(".lightbox-wrap").fadeOut(400)
          $("#image").html("")
        }
      })
      //# End of gamers 圖片 Lightbox

      $(".lang-switch").click(function () {
        $("#lang-modal").fadeIn(400)
        $(".head .title").text("Select Your Language")
      })

      //# Worldview
      //time line
      let ancords = document.querySelectorAll(".timeline .anchor")
      let timer
      let current = 0
      let triggerInit = false
      ancords.forEach(ele => {
        ele.addEventListener("click", () => {
          let currentpoint = ele.getAttribute("data-point")
          $(".anchor").removeClass("past-time-point")
          $(".anchor").each(function () {
            if ($(this).attr("data-point") <= currentpoint) {
              $(this).addClass("past-time-point")
            }
          })
          isFromAnchor = true
          $("#progress").attr("class", "point" + currentpoint)

          if (triggerInit) {
            clearInterval(timer)
            current = currentpoint
            playWorldview()
          }
        })
      })
      $(".anchor").eq(0).click()

      function playWorldview() {
        current++
        current = current > ancords.length - 1 ? 0 : current
      }

      let inViewportPlayOnce = true
      window.addEventListener("scroll", e => {
        let scrolled = window.pageYOffset

        // 剛好看得到一點worldview時，就要啟動了（手機版同）
        if (scrolled > 1200 && inViewportPlayOnce) {
          playWorldview()
          inViewportPlayOnce = false
          triggerInit = true
        }
      })

      function setIndex() {
        cards.forEach((ele, i) => {
          ele.dataset.slide = cardsIndexes[i]
        })
        ancords.forEach((ele, i) => {
          ele.dataset.slide = cardsIndexes[i]
        })
      }

      function setNumberToFirst(index) {
        for (let i = 0; i < index; i++) {
          cardsIndexes.unshift(cardsIndexes.pop())
        }
      }
      // slider
      $(".worldview-slider").each(function () {
        var $this = $(this)
        var $group = $this.find(".cards-box")
        var $slides = $this.find(".card")
        var currentIndex = 0
        var timeout

        function move(newIndex) {
          var animateLeft, slideLeft, infoSlideLeft, infoAnimateLeft

          advance()

          if ($group.is(":animated") || currentIndex === newIndex) {
            return
          }

          if (newIndex > currentIndex) {
            slideLeft = "100%"
            animateLeft = "-100%"
            infoSlideLeft = "+=+8000"
            infoAnimateLeft = "+=-8000"
          } else {
            slideLeft = "-100%"
            animateLeft = "100%"
            infoSlideLeft = "+=-8000"
            infoAnimateLeft = "+=+8000"
          }

          $slides.eq(newIndex).css({
            display: "block",
            left: slideLeft,
          })
          $slides.eq(currentIndex).find(".card-info").animate({
            left: infoSlideLeft,
          })
          $group.delay(300).animate(
            {
              left: animateLeft,
            },
            function () {
              $slides.eq(currentIndex).css({
                display: "none",
              })
              $slides.eq(newIndex).css({
                left: 0,
              })
              $group.css({
                left: 0,
              })
              $slides.eq(currentIndex).find(".card-info").animate({
                left: infoAnimateLeft,
              })
              currentIndex = newIndex
            }
          )
        }

        function advance() {
          clearTimeout(timeout)
          timeout = function () {
            if (currentIndex < $slides.length - 1) {
              move(currentIndex + 1)
            } else {
              move(0)
            }
          }
        }

        $(".anchor").click(function () {
          move($(this).attr("data-point"))
        })
      })
      //# End of Worldview

      //# Opening 視差滾動
      let opening = document.getElementById("opening")
      let opening_copy = document.querySelector("#opening-copy")
      let transition = document.getElementById("transition")

      // 檢查元素是否存在,避免在非首頁出錯
      if (!opening || !opening_copy || !transition) {
        return
      }

      let placeholderHeight = $(opening).outerHeight()
      let isScrollHandlerBound = false

      function hideOpening() {
        // 隱藏 opening 影片,避免遮擋後續內容
        opening.classList.add("hidden")
      }

      function showOpening() {
        // 顯示 opening 影片
        opening.classList.remove("hidden")
      }

      function setPlaceholder() {
        opening_copy.style.height = placeholderHeight + "px"
        opening.style.position = "fixed"
        opening.style.top = "0px"
      }

      function checkOpeningState() {
        let scrollTop = $(window).scrollTop()

        // 取得 transition 的實際位置 (可能需要等 DOM 完全載入)
        let transitionTop =
          transition.offsetTop ||
          transition.getBoundingClientRect().top + scrollTop

        if (transitionTop > 0 && transitionTop <= scrollTop) {
          // 滾動到 transition 時,隱藏 opening
          opening.style.position = "relative"
          opening.style.top = placeholderHeight - 40 + "px"
          opening.style.left = "-1px"
          opening_copy.style.height = 0
          hideOpening()
        } else {
          // 還在 opening 區域時,顯示 opening
          opening.style.left = "0px"
          setPlaceholder()
          showOpening()
        }
      }

      // 初始化時確保 opening 是顯示的
      setPlaceholder()
      showOpening() // 先強制顯示

      // 延遲一點再檢查狀態,確保 DOM 完全載入
      setTimeout(() => {
        checkOpeningState()
      }, 100)

      // 綁定 scroll 事件 (只綁定一次)
      if (!isScrollHandlerBound) {
        $(window).on("scroll.openingParallax", checkOpeningState)
        isScrollHandlerBound = true
      }
      //# Transition
      const texts_set = [
        ["REBOOT", "REVELATION"],
        ["RHAPSODY", "REBOOT"],
        ["RE-AWAKENING", "RHAPSODY"],
        ["REVELATION", "RE-AWAKENING"],
      ]

      const dictionary = [
        ["重啟", "甦醒", "反逆", "共%", "新秩序", "復仇", "革命", "揭露"],
        ["鵟翔曲", "反逆", "共鳴", "新x序", "復仇", "革*", "對抗", "重啟"],
        ["再。覺醒", "0鳴", "新秩序", "復仇", "革命", "#抗", "重逢", "鵟翔曲"],
        ["共鳴", "新秩序", "w仇", "革命", "對抗", "重逢", "甦醒", "反逆"],
      ]

      function ctkSplitFlap(ele, texts) {
        for (let i = 0; i < texts.length; i++) {
          setTimeout(function () {
            ele.innerText = texts[i]
          }, 250 * i)
        }
      }

      let splitflaps = document.querySelectorAll(".splitflap")

      if ($("html").attr("lang") == "zh-TW") {
        splitflaps.forEach((ele, index) => {
          setInterval(() => {
            ctkSplitFlap(ele, dictionary[index])
          }, 4000)
        })
      } else {
        splitflaps.forEach((ele, index) => {
          splitFlap(ele, texts_set[index], {
            timeOut: 1500,
            tickTimeOut: 100,
            nbJumpIterations: 4,
          })
        })
      }

      // 這邊處理opening 中心saga換字,放這不放openingjs是因為要用import
      const brand_texts_set = [
        [
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "5",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
        ],
        [
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "5",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
          "S",
        ],
      ]
      let brand_splitflaps = document.querySelectorAll(".opening_center .split")
      brand_splitflaps.forEach((ele, index) => {
        setTimeout(() => {
          splitFlap(ele, brand_texts_set[index], {
            timeOut: 160,
            tickTimeOut: 50,
            nbJumpIterations: 4,
          })
        }, 8000)
      })
      // opening 中心saga換字結束

      //Language switch
      // 從 __PATH_PREFIX__ 取得正確的路徑前綴
      const pathPrefix =
        typeof __PATH_PREFIX__ !== "undefined" ? __PATH_PREFIX__ : ""

      var urlPath = window.location.pathname.split("/") //抓當下的 url 用 / 分開
      let lang = urlPath[urlPath.length - 2]

      $(".lang-content li button").each(function () {
        if ($(this).data("lang") == lang) {
          $(this).addClass("active")
        }
      })

      // 檢查是否在根路徑 (例如 /microsite/rog-saga/ 或 /rog-saga/)
      const pathParts = window.location.pathname.split("/").filter(p => p)
      const lastPart = pathParts[pathParts.length - 1]

      // 如果最後一部分是 "rog-saga" 或 "microsite",表示在英文首頁
      if (lastPart === "rog-saga" || pathParts.length <= 2) {
        $(".lang-content li button[data-lang='en']").addClass("active")
      }

      function langSwitch() {
        if ($(this).data("lang") == "en") {
          window.location.href = `${pathPrefix}/`
        } else {
          window.location.href = `${pathPrefix}/de`
        }
      }
    })
  }

  if (document.readyState === "complete") {
    runOnClient()
  } else {
    window.addEventListener("load", runOnClient)
  }
}

// Gatsby 路由更新後重新檢查 opening 狀態
export const onRouteUpdate = ({ location, prevLocation }) => {
  // 等待 DOM 更新完成後執行
  setTimeout(() => {
    const opening = document.getElementById("opening")
    const opening_copy = document.querySelector("#opening-copy")
    const transition = document.getElementById("transition")

    if (!opening || !opening_copy || !transition) {
      return
    }

    const placeholderHeight = $(opening).outerHeight()
    const scrollTop = $(window).scrollTop()

    function hideOpening() {
      opening.classList.add("hidden")
    }

    function showOpening() {
      opening.classList.remove("hidden")
    }

    function setPlaceholder() {
      opening_copy.style.height = placeholderHeight + "px"
      opening.style.position = "fixed"
      opening.style.top = "0px"
    }

    // 取得 transition 的實際位置
    let transitionTop =
      transition.offsetTop || transition.getBoundingClientRect().top + scrollTop

    // 檢查並設定狀態
    if (transitionTop > 0 && transitionTop <= scrollTop) {
      opening.style.position = "relative"
      opening.style.top = placeholderHeight - 40 + "px"
      opening.style.left = "-1px"
      opening_copy.style.height = 0
      hideOpening()
    } else {
      opening.style.left = "0px"
      setPlaceholder()
      showOpening()
    }
  }, 100)
}
